import type { UserNotificationDTO } from '@hooks/queries/notifications/userNotifications.models';
import { routePaths } from '@screens/routes';

type NdviThresholdContent = UserNotificationDTO['user_notification']['content'] | undefined;

const NDVI_CHANGE_REPORT_PATH = 'ndvi-change';
const FALLBACK_TITLE_KEY = 'report_title';
const DETAILS_KEY = 'report_details';

function formatThreshold(threshold: number, language: string) {
  return new Intl.NumberFormat(language).format(threshold);
}

function buildFarmPath(content: NdviThresholdContent) {
  const organizationId = content?.org_id;
  const propertyId = content?.farm_id;

  return organizationId && propertyId
    ? `${routePaths.organizations}/${organizationId}/properties/${propertyId}`
    : undefined;
}

function buildFieldPath(content: NdviThresholdContent) {
  const farmPath = buildFarmPath(content);
  const fieldId = content?.field_id;

  if (!farmPath || !fieldId) return undefined;

  const currentImage = content?.current_image_id;
  const previousImage = content?.previous_image_id;

  const params = new URLSearchParams({
    field: fieldId,
    ...(currentImage && previousImage
      ? { current_image: currentImage, previous_image: previousImage }
      : {}),
  });

  return `${farmPath}?${params.toString()}`;
}

export {
  buildFarmPath,
  buildFieldPath,
  DETAILS_KEY,
  FALLBACK_TITLE_KEY,
  formatThreshold,
  NDVI_CHANGE_REPORT_PATH,
};
export type { NdviThresholdContent };
